<template>
  <div class="center">
    <nav-header :tab-index="1" />
    <!-- <center-header></center-header> -->

    <div class="wrapper">
      <img src="/images/index/icon.png" class="center-icon" alt="">
      <div class="personalCon">
        <el-aside class="admin-aside">
          <!-- <div class="admin-menu-title">
            <img src="/images/personal/home.png" alt="">
            首页
          </div> -->
          <el-menu :default-active="activeMenu" class="admin-menu" background-color="#FFFFFF" text-color="#bfcbd9"
            active-text-color="#409EFF" router unique-opened>
            <el-menu-item index="/index">
              <i class="el-icon-s-home"></i>
              <span slot="title">首页</span>
            </el-menu-item>
            <el-menu-item index="/messageList">
              <i class="el-icon-message"></i>
              <span slot="title">消息中心</span>
            </el-menu-item>
            <el-menu-item index="/cart">
              <i class="el-icon-shopping-cart-2"></i>
              <span slot="title">我的购物车<span v-if="cartNum > 0" class="cartNum">{{ cartNum }}</span>
              </span>
            </el-menu-item>
            <el-submenu index="order-submenu">
              <template slot="title">
                <i class="el-icon-document"></i>
                <span>订单中心</span>
              </template>
              <el-menu-item index="/orderList">
                <i class="el-icon-s-refund"></i>
                <span>我的订单</span>
              </el-menu-item>
              <el-menu-item index="/refundOrderList">
                <i class="el-icon-s-refund"></i>
                <span>售后订单</span>
              </el-menu-item>
              <el-menu-item index="/movieOrderList">
                <i class="el-icon-s-movie"></i>
                <span>电影订单</span>
              </el-menu-item>
              <el-menu-item index="/couponOrderList">
                <i class="el-icon-s-coupon"></i>
                <span>卡券订单</span>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="asset-submenu">
              <template slot="title">
                <i class="el-icon-wallet"></i>
                <span>资产中心</span>
              </template>
              <el-menu-item index="/benefitCard">
                <i class="el-icon-s-benefit-card"></i>
                <span>我的福利卡</span>
              </el-menu-item>
              <el-menu-item index="/specialZone">
                <i class="el-icon-s-special-zone"></i>
                <span>专区余额记录</span>
              </el-menu-item>
              <el-menu-item index="/agriculturalCard">
                <i class="el-icon-s-agricultural-card"></i>
                <span>我的助农卡</span>
              </el-menu-item>
              <el-menu-item index="/cardBag">
                <i class="el-icon-s-card-bag"></i>
                <span>我的卡包</span>
              </el-menu-item>
              <el-menu-item index="/exchangeRecord">
                <i class="el-icon-s-exchange-record"></i>
                <span>兑换记录</span>
              </el-menu-item>
              <el-menu-item index="/cardTurnRecord">
                <i class="el-icon-s-card-turn-record"></i>
                <span>卡转赠记录</span>
              </el-menu-item>
              <el-menu-item v-if="userAuthType == 1" index="/lineCredit">
                <i class="el-icon-s-line-credit"></i>
                <span>资质认证</span>
              </el-menu-item>
              <el-menu-item v-else-if="userAuthType == 0">
                <i class="el-icon-s-line-credit"></i>
                <span>资质认证待审核</span>
              </el-menu-item>
              <el-menu-item v-else index="/qualification">
                <i class="el-icon-s-line-credit"></i>
                <span>资质认证</span>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="account-submenu">
              <template slot="title">
                <i class="el-icon-user"></i>
                <span>账号设置</span>
              </template>
              <el-menu-item index="/userInfo">
                <i class="el-icon-s-user"></i>
                <span>个人信息</span>
              </el-menu-item>
              <el-menu-item index="/addressList">
                <i class="el-icon-s-address"></i>
                <span>收货地址</span>
              </el-menu-item>
              <el-menu-item index="/invoiceList">
                <i class="el-icon-s-invoice"></i>
                <span>发票管理</span>
              </el-menu-item>
              <el-menu-item index="/myComment">
                <i class="el-icon-s-collect"></i>
                <span>我的评价</span>
              </el-menu-item>
              <el-menu-item index="/collectRecord">
                <i class="el-icon-s-collect"></i>
                <span>我的收藏</span>
              </el-menu-item>
              <el-menu-item index="/browseRecord">
                <i class="el-icon-s-browse-record"></i>
                <span>浏览记录</span>
              </el-menu-item>
              <el-menu-item index="/feedback">
                <i class="el-icon-s-feedback"></i>
                <span>意见反馈</span>
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </el-aside>
        <div class="center-left" v-if="false">
          <div class="name">订单中心</div>
          <div class="word" :class="personType == 1 ? 'check' : ''" @click="jump(1, 'orderList')">我的订单</div>
          <div class="word" :class="personType == 16 ? 'check' : ''" @click="jump(16, 'refundOrderList')">售后订单</div>
          <div class="word" :class="personType == 11 ? 'check' : ''" @click="jump(11, 'movieOrderList')">电影订单</div>
          <div class="word" :class="personType == 17 ? 'check' : ''" @click="jump(17, 'couponOrderList')">卡券订单</div>
          <div class="name">资产中心</div>
          <!-- <div class="word"
             :class="personType==2?'check':''"
             @click="jump(2,'myIntegral')">我的积分</div> -->

          <div class="word" :class="personType == 3 ? 'check' : ''" @click="jump(3, 'benefitCard')">我的福利卡</div>
          <div class="word" :class="personType == 22 ? 'check' : ''" @click="jump(22, 'specialZone')">专区余额记录</div>
          <div class="word" :class="personType == 12 ? 'check' : ''" @click="jump(12, 'agriculturalCard')">我的助农卡</div>
          <div class="word" :class="personType == 13 ? 'check' : ''" @click="jump(13, 'cardBag')">我的卡包</div>
          <div class="word" :class="personType == 14 ? 'check' : ''" @click="jump(14, 'exchangeRecord')">兑换记录</div>
          <div class="word" :class="personType == 15 ? 'check' : ''" @click="jump(15, 'cardTurnRecord')">卡转赠记录</div>
          <div class="word" :class="personType == 4 ? 'check' : ''" @click="jump(4, '')">资质认证</div>
          <div class="name">账号设置</div>
          <div class="word" :class="personType == 5 ? 'check' : ''" @click="jump(5, 'userInfo')">个人信息</div>
          <div class="word" :class="personType == 6 ? 'check' : ''" @click="jump(6, 'addressList')">收货地址</div>
          <div class="word" :class="personType == 7 ? 'check' : ''" @click="jump(7, 'invoiceList')">发票管理</div>
          <div class="word" :class="personType == 11 ? 'check' : ''" @click="jump(11, 'myComment')">我的评价</div>
          <div class="word" :class="personType == 9 ? 'check' : ''" @click="jump(9, 'collectRecord')">我的收藏</div>
          <div class="word" :class="personType == 10 ? 'check' : ''" @click="jump(10, 'browseRecord')">浏览记录</div>
          <div class="word" :class="personType == 8 ? 'check' : ''" @click="jump(8, 'feedback')">意见反馈</div>
        </div>
        <div class="center-right">
          <router-view></router-view>
        </div>
      </div>
      <nav-footer></nav-footer>
    </div>

  </div>
</template>
<script>
import CenterHeader from '@/components/CenterHeader';
import NavFooter from '@/components/NavFooter';
import NavHeader from '@/components/NavHeader';
import { mapState } from 'vuex';
export default {
  name: 'PersonalCenter',
  components: {
    CenterHeader,
    NavFooter,
    NavHeader
  },
  data() {
    return {
      type: 0,
      userAuthType: -1,
      userAuth: {},
      cartNum: 0,
    };
  },
  mounted() {
    this.getUserAuth()
    this.getCartNum()
  },
  computed: {
    ...mapState(['personType']),
    activeMenu() {
      console.log(this.$route.path)
      return this.$route.path
    }
  },
  methods: {
    // 查看订单
    jump(type, page) {
      console.log(type);
      this.type = type
      this.$store.dispatch('saveMessageType', '')
      this.$store.dispatch('savePersonType', type)
      if (type == 4) {
        if (this.userAuthType == 1) {
          this.$router.push({
            name: 'lineCredit',
          });
        } else if (this.userAuthType == 0) {
          this.$message.warning('资质正在审核中...')
        } else {
          this.$router.push({
            name: 'qualification',
          });
        }
      } else {
        this.$router.push({
          name: page,
        });
      }
      this.$forceUpdate()
    },
    // 获取授信信息
    getUserAuth() {
      this.$api.mall.getUserAuth().then(res => {
        if (res.code == 200) {
          if (res.data) {
            this.userAuthType = Number(res.data.status)
            this.userAuth = res.data
          }
        }
      })
    },

    // 获取购物车数量
    getCartNum() {
      this.$api.mall.getCarCount().then(res => {
        if (res.code == 200) {
          this.$store.dispatch('saveCarCount', res.data)
          this.cartNum = res.data
        }
      })
    },
  }
};
</script>
<style lang="scss">
.center {
  cursor: pointer;


  .wrapper {
    min-height: calc(100vh - 36px);
    background-image: url('/images/index/defaultBack.png');
    background-size: 100% 966px;
    background-position: 0 0;
    background-repeat: no-repeat;
    background-color: #F2F3FA;
    padding: 0 346px 0;
    box-sizing: border-box;

    .personalCon {
      display: flex;
      justify-content: space-between;
      align-content: flex-start;
      position: relative;
    }

    .center-icon {
      width: 237px;
      height: 49px;
      margin: 30px 0;
    }

    .admin-aside {
      width: 204px !important;
      background: #FFFFFF;
      padding: 6px 16px;
      box-sizing: border-box;

      .el-menu {
        border-right: none !important;

        .el-menu-item {
          padding-left: 10px !important;
          color: #111111 !important;
          box-sizing: border-box !important;
          min-width: auto !important;
          font-weight: 700 !important;

          i {
            color: #111111 !important;
          }

          &:hover {
            background-color: #FFE2E1 !important;
            color: #FF1D18 !important;

            i {
              color: #FF1D18 !important;
            }
          }

          &.is-active {
            background-color: #FFE2E1 !important;
            color: #FF1D18 !important;

            i {
              color: #FF1D18 !important;
            }
          }
        }

        .el-submenu {

          .el-submenu__title {
            padding-left: 10px !important;

            i {
              color: #111111 !important;
            }

            &:hover {
              background-color: #ffffff !important;
              color: #FF1D18 !important;

              span {
                color: #FF1D18 !important;
              }

              i {
                color: #FF1D18 !important;
              }
            }

            span {
              color: #111111 !important;
              font-size: 14px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
            }
          }

          &.is-active>.el-submenu__title {
            span {
              color: #FF1D18 !important;
              font-size: 14px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
            }

            i {
              color: #FF1D18 !important;
            }
          }
        }
      }

      .admin-menu-title {
        width: 172px;
        height: 41px;
        background: #FFE2E1;
        border-radius: 4px;
        font-size: 14px;
        color: #FF1D18;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding-left: 12px;
        box-sizing: border-box;

        img {
          width: 12px;
          height: 12px;
          margin-right: 6px;
        }
      }
    }

    .center-left {
      width: 180px;
      height: 860px;
      background-color: #fff;
      padding: 10px 24px;
      box-sizing: border-box;

      .name {
        font-size: 16px;
        font-weight: bold;
        line-height: 40px;
      }

      .word {
        font-size: 14px;
        color: #999;
        line-height: 40px;
      }

      .check {
        color: #004098;
        // font-weight: bold;
      }
    }

    .center-right {
      width: calc(100% - 204px - 30px);
      height: 100%;
      margin-left: 30px;
    }
  }

  .cartNum {
    font-size: 14px;
    color: #FFFFFF;
    line-height: 18px;
    vertical-align: middle;
    padding: 0 5px;
    background: #FF1D18;
    border-radius: 4px;
    margin-left: 8px;
    display: inline-block;
    font-weight: normal;
  }
}
</style>